<template>
<div class="chapter">
<div class="inner_page">
<p class="s3"><br/><br/><br/>To Susanna, Leon, Felix and Edie</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?69752dce